import {
  AmILoggedInApplicantResponse,
  useAmILoggedInApplicant,
} from "../../modules/api-docs";
import { useMemo } from "react";

const useGetApplicantLoginInfo = () => {
  const amILoggedInApplicant = useAmILoggedInApplicant();

  return {
    applicantLoginInfo: useMemo(() => {
      if (amILoggedInApplicant.isSuccess) {
        return amILoggedInApplicant.data;
      } else {
        return {
          success: false,
          fname: "",
          lname: "",
          email: "",
          id: null,
        } as AmILoggedInApplicantResponse;
      }
    }, [amILoggedInApplicant]),
    query: amILoggedInApplicant,
  };
};

export default useGetApplicantLoginInfo;
